'use strict';exports.__esModule = true;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _reactRouter = require('react-router');
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);
var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);
var _has = require('lodash/has');var _has2 = _interopRequireDefault(_has);


var _MobileContacts = require('../../MobileContacts/MobileContacts');var _MobileContacts2 = _interopRequireDefault(_MobileContacts);
var _PropertyDetailedForm = require('../../../containers/PropertyDetailedContactsUsForm/PropertyDetailedForm');var _PropertyDetailedForm2 = _interopRequireDefault(_PropertyDetailedForm);



var _analyticsManager = require('../../../utils/analytics/analyticsManager');
var _analyticsConstants = require('../../../utils/analytics/analyticsConstants');
var _formatPhoneNumber = require('../../../utils/formatPhoneNumber');
var _modifyImageLink = require('../../../utils/modifyImageLink');var _modifyImageLink2 = _interopRequireDefault(_modifyImageLink);
var _constants = require('../../../constants');
var _images_placeholder = require('../../../../static/images/images_placeholder.svg');var _images_placeholder2 = _interopRequireDefault(_images_placeholder);
var _constructLink = require('../../../helpers/constructLink');
var _components = require('../../../components');

var _BasicInformation = require('./BasicInformation.scss');var _BasicInformation2 = _interopRequireDefault(_BasicInformation);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;} // Components
// Helpers
// Styles
var Contacts = function (_Component) {_inherits(Contacts, _Component);function Contacts(props) {_classCallCheck(this, Contacts);var _this = _possibleConstructorReturn(this,
    _Component.call(this, props));_this.
















    handleCopy = function () {
      var textNode = document.createElement('span');
      textNode.textContent = _this.phoneNumber;
      document.body.appendChild(textNode);
      var range = document.createRange();
      range.selectNode(textNode);
      window.getSelection().removeAllRanges();
      window.getSelection().addRange(range);

      document.execCommand('copy');
      window.getSelection().removeAllRanges();
      document.body.removeChild(textNode);
      _this.setState({ isCopiedPhone: true }, function () {return setTimeout(function () {return _this.setState({ isCopiedPhone: false });}, 5000);});
    };_this.


    handleClick = function (type) {var
      propertyId = _this.props.data.propertyId;

      if (!_this.state.phoneIsRevealed[type]) {
        _this.handleShowPhone(type);
      } else {
        (0, _analyticsManager.trackGTM)({ name: _analyticsConstants.eventCategory.contactViews });
        // trackGTM({
        //   name: this.props.searchOption === 'forSale'
        //     ? eventCategory.contactViewsSale
        //     : eventCategory.contactViewsRent
        //   }
        // );
        (0, _analyticsManager.trackEvent)(_analyticsConstants.eventCategory.property, _this.props.searchOption === 'forSale' ? _analyticsConstants.eventLabel.contactViewsSale : _analyticsConstants.eventLabel.contactViewsRent);
        _this.props.incrementClicks({ propertyId: propertyId, action: _constants.analyticsEventAction.SHOW_NUMBER });
        (0, _analyticsManager.trackEvent)(_analyticsConstants.eventCategory.propertyDetails, _analyticsConstants.eventAction.show, _analyticsConstants.eventLabel.phoneNumber);
      }
    };_this.

    handleShowPhone = function () {var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'primary';var
      propertyId = _this.props.data.propertyId;

      (0, _analyticsManager.trackGTM)({ name: _analyticsConstants.eventCategory.contactViews });
      // trackGTM({
      //   name: this.props.searchOption === 'forSale'
      //     ? eventCategory.contactViewsSale
      //     : eventCategory.contactViewsRent
      //   }
      // );
      (0, _analyticsManager.trackEvent)(_analyticsConstants.eventCategory.property, _this.props.searchOption === 'forSale' ? _analyticsConstants.eventLabel.contactViewsSale : _analyticsConstants.eventLabel.contactViewsRent);
      _this.props.incrementClicks({ propertyId: propertyId, action: _constants.analyticsEventAction.SHOW_NUMBER });
      (0, _analyticsManager.trackEvent)(_analyticsConstants.eventCategory.propertyDetails, _analyticsConstants.eventAction.show, _analyticsConstants.eventLabel.phoneNumber);

      return _this.setState(function (prevState) {var _Object$assign, _showTooltip;return {
          phoneIsRevealed: Object.assign({},
          prevState.phoneIsRevealed, (_Object$assign = {}, _Object$assign[
          type] = true, _Object$assign)),

          showTooltip: (_showTooltip = {}, _showTooltip[
          type] = true, _showTooltip) };},

      function () {
        setTimeout(function () {var _showTooltip2;
          _this.setState({
            showTooltip: (_showTooltip2 = {}, _showTooltip2[
            type] = false, _showTooltip2) });


        }, 3000);
      });
    };_this.

    renderTooltip = function () {
      var title = _this.props.translate('propertyDetails', 'contacts', 'onMapTitle').
      split('%s');
      title.splice(1, 0, _react2.default.createElement('span', { key: 'contacts', className: _BasicInformation2.default.logoTitle }, 'OnMap'));

      return title;
    };_this.

    renderMobileContact = function (type) {var _this$props =
      _this.props,contacts = _this$props.contacts,translate = _this$props.translate,isForeign = _this$props.isForeign,data = _this$props.data;
      var handleClick = function handleClick() {return _this.handleClick(type);};

      if (contacts.secondary) {
        return (
          _react2.default.createElement('div', { className: _BasicInformation2.default.buttons },
            _react2.default.createElement('button', { type: 'button', className: (0, _classnames2.default)(_BasicInformation2.default.hideText, _BasicInformation2.default.wide), onClick: function onClick() {return _this.setState({ isModalOpen: true });} },
              _react2.default.createElement('span', { className: (0, _classnames2.default)('icon icon-phone-fill', _BasicInformation2.default.iconsIndent) }),
              translate('propertyDetails', 'seeContactInformation')),

            _react2.default.createElement(_MobileContacts2.default, {
                contacts: contacts,
                locale: _this.props.locale,
                isCompanyActive: _this.props.isCompanyActive,
                realEstateData: _this.props.realEstateData,
                isOpen: _this.state.isModalOpen,
                onRequestClose: function onRequestClose() {return _this.setState({ isModalOpen: false, showContactForm: false });},
                onMapTitle: _this.renderTooltip(),
                translate: translate,
                contactButton:
                _react2.default.createElement('button', {
                    type: 'button',
                    className: (0, _classnames2.default)(_BasicInformation2.default.scrollButton),
                    onClick: function onClick() {return _this.setState({ showContactForm: true });} },

                  translate('propertyDetails', 'contacts', 'sendMessage')) },



              _this.state.showContactForm &&
              _react2.default.createElement(_PropertyDetailedForm2.default, {
                isModal: false,
                entityId: data.propertyId,
                isForeign: isForeign,
                entityType: 'property' }))));





      }
      return (
        _react2.default.createElement('div', { className: _BasicInformation2.default.buttons },
          _react2.default.createElement('button', {
              type: 'button',
              className: (0, _classnames2.default)(_BasicInformation2.default.scrollButton),
              onClick: _this.props.scrollToForm },

            translate('propertyDetails', 'contacts', 'sendMessage')),

          (0, _has2.default)(_this.props, 'contacts.primary.phone') &&
          _react2.default.createElement('a', {
              href: 'tel:' + (0, _formatPhoneNumber.authenticationFormatPhoneNumber)(contacts.primary.phone),
              className: _BasicInformation2.default.hideText,
              onClick: handleClick },

            _react2.default.createElement('span', { className: (0, _classnames2.default)('icon icon-phone-fill', _BasicInformation2.default.iconsIndent) }),

            _this.state.phoneIsRevealed[type] ?
            (0, _formatPhoneNumber.formatPhoneNumber)((0, _formatPhoneNumber.clearPhoneNumber)(contacts.primary.phone)) :
            translate('propertyDetails', 'call'))));





    };_this.

    renderContactButton = function (type) {var _this$props2 =
      _this.props,translate = _this$props2.translate,contacts = _this$props2.contacts;

      var phone = (0, _get2.default)(contacts, type + '.phone');

      return _this.state.phoneIsRevealed[type] ?
      _react2.default.createElement('button', { type: 'button', className: (0, _classnames2.default)(_BasicInformation2.default.hideText, _BasicInformation2.default.textRevealed) },
        (0, _formatPhoneNumber.formatPhoneNumber)((0, _formatPhoneNumber.clearPhoneNumber)(phone)),
        _this.state.showTooltip[type] &&
        _react2.default.createElement(_components.OMTooltip, {
          locale: _this.props.locale,
          className: 'contact',
          msg:
          _react2.default.createElement('p', { className: _BasicInformation2.default.message }, _this.renderTooltip()),

          hideCloseButton: true })) :




      _react2.default.createElement('button', { type: 'button', className: _BasicInformation2.default.hideText, onClick: function onClick() {return _this.handleShowPhone(type);} },
        _react2.default.createElement('span', { className: (0, _classnames2.default)('icon icon-phone-fill', _BasicInformation2.default.iconsIndent) }),
        translate('propertyDetails', 'contacts', 'showNumber'));


    };_this.

    renderContactBlock = function (type) {var
      translate = _this.props.translate;
      var companyName = (0, _get2.default)(_this.props, 'realEstateData.companyName');
      var logo = (0, _get2.default)(_this.props, 'realEstateData.logo');
      var agencyPageExist = !!(0, _get2.default)(_this.props, 'contacts.' + type + '.agency_page');
      var name = (0, _get2.default)(_this.props, 'contacts.' + type + '.name');

      return (
        _react2.default.createElement('div', { className: _BasicInformation2.default.contactsContainer },
          _react2.default.createElement('div', null,
            logo && type === 'primary' ? _this.renderLogo(logo, agencyPageExist) :
            _react2.default.createElement('i', { className: 'icon icon-user' }),
            (name || companyName) &&
            _react2.default.createElement('div', { className: _BasicInformation2.default.primaryWrapper },
              companyName && type === 'primary' &&
              _react2.default.createElement('div', { className: (0, _classnames2.default)(_BasicInformation2.default.contactRow, _BasicInformation2.default.companyRow) },
                _this.renderCompanyLink(companyName)),


              name &&
              _react2.default.createElement('p', { title: name, className: _BasicInformation2.default.primaryName },
                name))),





          _react2.default.createElement('div', { className: _BasicInformation2.default.buttons },
            type === 'primary' &&
            _react2.default.createElement('button', {
                type: 'button',
                className: (0, _classnames2.default)(_BasicInformation2.default.hideText, _BasicInformation2.default.scrollButton),
                onClick: _this.props.scrollToForm },

              translate('propertyDetails', 'contacts', 'sendMessage')),


            (0, _has2.default)(_this.props, 'contacts.' + type + '.phone') && _this.renderContactButton(type))));



    };_this.

    renderCompanyLink = function (content) {var _cx;
      var agencyId = (0, _get2.default)(_this.props, 'realEstateData.agencyId');
      var isCompanyActive = _this.props.isCompanyActive;
      return (
        _react2.default.createElement(_reactRouter.Link, {
            to: isCompanyActive && (0, _constructLink.constructCompanyLink)(_this.props.locale, agencyId),
            className: (0, _classnames2.default)((_cx = {}, _cx[_BasicInformation2.default.disabledAgencyLink] = !isCompanyActive, _cx), _BasicInformation2.default.textAlignment),
            title: content },

          content));


    };_this.

    renderLogo = function (logoLink) {
      var logo =
      _react2.default.createElement('img', {
        src: logoLink ? (0, _modifyImageLink2.default)(logoLink, _constants.imageModifierTypes.LOGO) : _images_placeholder2.default,
        alt: '',
        className: _BasicInformation2.default.realEstateIcon });



      return _this.renderCompanyLink(logo);
    };_this.phoneNumber = props.contacts && props.contacts.primary && props.contacts.primary.phone;_this.state = { isCopiedPhone: false, phoneIsRevealed: { primary: false, secondary: false }, showTooltip: { primary: false, secondary: false }, isModalOpen: false, showContactForm: false };return _this;}Contacts.prototype.

  render = function render() {var _props =



    this.props,isMobile = _props.isMobile,contacts = _props.contacts;

    if (isMobile) {
      return this.renderMobileContact('primary');
    }

    return (
      _react2.default.createElement('div', { className: _BasicInformation2.default.contact },
        this.renderContactBlock('primary'),
        !!contacts.secondary &&
        this.renderContactBlock('secondary')));



  };return Contacts;}(_react.Component);exports.default = Contacts;


Contacts.propTypes = {
  locale: _propTypes2.default.string,
  translate: _propTypes2.default.func,
  realEstateData: _propTypes2.default.object,
  data: _propTypes2.default.object,
  contacts: _propTypes2.default.object,
  searchOption: _propTypes2.default.string,
  scrollToForm: _propTypes2.default.func,
  incrementClicks: _propTypes2.default.func,
  isForeign: _propTypes2.default.bool,
  isMobile: _propTypes2.default.bool,
  isCompanyActive: _propTypes2.default.bool,
  isNative: _propTypes2.default.bool };module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/PropertyDetailedInfo/BasicInformation/Contacts.js
// module id = 2787
// module chunks = 0